import { matchPath } from 'react-router';

import routes from '@/assets/constants/routes-no.ts';
import { makeHasEnded } from '@/competitions/_common/utils.ts';

import {
  WAKE_UP_2024_CAMPAIGN_END_DATE,
  WAKE_UP_PART2_2024_CAMPAIGN_END_DATE,
} from '../../../config.ts';

export const useHasEnded = makeHasEnded(({ location }) =>
  matchPath(routes.WAKE_UP_PART2_2024_COMPETITION, location.pathname)
    ? WAKE_UP_PART2_2024_CAMPAIGN_END_DATE
    : WAKE_UP_2024_CAMPAIGN_END_DATE,
);
